import { render, staticRenderFns } from "./AddColourView.vue?vue&type=template&id=2317072b"
import script from "./AddColourView.vue?vue&type=script&lang=js"
export * from "./AddColourView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports